import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {APIService} from "../../../services/APIService";

// No API service injection needed here; bearer token is sourced from env in APIService

@Component({
  selector: 'app-coins-dialogue',
  templateUrl: './coins-dialogue.component.html',
  styleUrls: ['./coins-dialogue.component.css']
})
export class CoinsDialogueComponent {
  mode: 'give' | 'take' = 'give';
  amount: number | null = null;
  reason: string = '';
  playerCoins: number | null = null;

  constructor(
    protected apiService: APIService,
    private dialogRef: MatDialogRef<CoinsDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.refreshCoins();
  }

  get canSubmit(): boolean {
    return this.amount !== null && Number(this.amount) > 0;
  }

  submit() {
    if (!this.canSubmit) return;
    this.dialogRef.close({ mode: this.mode, amount: Number(this.amount), reason: this.reason });
  }

  private async refreshCoins() {
    try {
      if (!this.data.player) return;
      this.playerCoins = await this.apiService.getPlayerCoins(this.data.player.uuid);
    } catch (e) {
      // leave playerCoins as-is on error
    }
  }

  formatNumber(number: number): string {
    return new Intl.NumberFormat("en-en").format(number);
  }
}
